import React, {useEffect, useState} from "react";
import {Grid, MenuItem, Select, Stack, Typography} from "@mui/material";
import {makeStyles} from "@mui/styles";
import LeaderboardPOTYTable from "../LeaderboardPOTYTable";
import {apiGet} from "../../../utils/apiRequests";
import ApiEndpoints from "../../../utils/ApiEndpoints";

const useStyles = makeStyles((theme) => ({
    outlineInputBorder: {
        "& * > fieldset > legend": {
            display: "none",
        },
        "& > fieldset > legend > span": {
            display: "none",
        },
    },
}));

export default function LeaderboardPOTYList() {
    const classes = useStyles();
    const [leagueList, setLeagueList] = useState([]);
    const [leagueVal, setLeagueVal] = useState("");
    const [leagueId, setLeagueId] = useState("");
    const [leagueInitialId, setLeagueInitialId] = useState("");
    const [isInitial, setIsInitial] = useState(true);

    const getLeagueList = () => {
        apiGet(
            `${ApiEndpoints.league.base}${ApiEndpoints.league.listleaguePOTY}`,
            (res) => {
                setLeagueList(res?.leagues);
                setLeagueVal(res?.leagues[0].name);
                setLeagueInitialId(res?.leagues[0]._id);
            },
            (err) => {
            }
        );
    };

    useEffect(() => {
        getLeagueList();
    }, []);

    useEffect(() => {
        setLeagueInitialId(leagueInitialId);
    }, [leagueInitialId]);

    return (
        <Grid container>
            <Grid item xs={12} p={2}>
                <Grid item container>
                    <Grid item xs={12} lg={8}>
                        <Typography variant="h6" fontWeight={"700"}>
                            Leaderboard
                        </Typography>
                    </Grid>

                    <Grid item xs={12} lg={4} marginTop={{xs: "20px", lg: 0}}>
                        <Stack>
                            <Typography color={"#06623B"} fontWeight={"500"}>
                                Please Select League
                            </Typography>

                            <Select
                                variant="outlined"
                                className={classes.outlineInputBorder}
                                value={leagueVal}
                                label="."
                            >
                                {leagueList &&
                                    leagueList.map((item, i) => {
                                        return (
                                            <MenuItem
                                                key={item?._id}
                                                value={item?.name}
                                                onClick={(e) => {
                                                    setLeagueVal(item?.name);
                                                    setLeagueId(item?._id);
                                                    setIsInitial(false);
                                                }}
                                            >
                                                <Grid container item>
                                                    <Grid item xs={10}>
                                                        <Typography>{item?.name}</Typography>
                                                    </Grid>
                                                </Grid>
                                            </MenuItem>
                                        );
                                    })}
                            </Select>
                        </Stack>
                    </Grid>
                </Grid>

                <Grid item container>
                    <Grid item xs={12} mt={2}>
                        <LeaderboardPOTYTable
                            leagueId={leagueId}
                            leagueInitialId={leagueInitialId}
                            isInitial={isInitial}
                        />
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
}
